module.exports = __webpack_public_path__ + "static/media/image44.daff0a44.jpg";